import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { SafeUrlPipe } from 'src/safe-url.pipe';

@Component({
  selector: 'app-preview-whatsapp-template',
  imports: [SharedModule,SafeUrlPipe],
  templateUrl: './preview-whatsapp-template.component.html',
  styleUrl: './preview-whatsapp-template.component.scss'
})
export class PreviewWhatsappTemplateComponent {

  @Output() reload = new EventEmitter<any>();
  @Input() templateDataToEdit: any = {};
  @Output() closeDialog = new EventEmitter<any>();
  @Input() showHeader: boolean = true;
  @Input() showDilogContentClass: boolean = true;
  templateType: string = '';
  mediaId: string = '';
  header: string = '';
  footer: string = '';
  quickReplyButtons: any[] = [];
  urlButtons: any[] = [];
  callButtons: any[] = [];
  countQuickReplyButton: number = 0;
  countCTAButtonForURL: number = 0;
  renderedData: any = {};

  currentTime: string = '';
  timerId: any;

  showAllVariables: boolean = false;




  ngOnInit() {
    this.handleOpenPreviewDialog(this.templateDataToEdit);
    this.updateTime();
    this.timerId = setInterval(() => this.updateTime(), 60000); // Update every minute
  }

  ngOnDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  }

  updateTime() {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12; // Convert 24-hour to 12-hour format
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    this.currentTime = `${formattedHours}:${formattedMinutes} ${ampm}`;
  }



  handleOpenPreviewDialog(template: any) {
    console.log('template 1555', template);
    this.templateType = template.templateType;

    console.log('templateType', this.templateType);

    if (template.templateType === 'IMAGE' || template.templateType === 'VIDEO' || template.templateType === 'DOCUMENT') {
      const data = JSON.parse(template.meta);
      this.mediaId = data.mediaId;

      console.log('mediaId', this.mediaId);
    }
    const { header, body, footer } = this.splitString(template.containerMeta);
    this.header = header;
    this.footer = footer;
    const { quickReplyButtons, urlButtons, callButtons } = this.parseButtons(template.containerMeta);

    this.quickReplyButtons = quickReplyButtons.map((button: string) => ({ value: button }));

    this.urlButtons = urlButtons.map((button: any) => ({ title: button.text, urlType: button.urlType, value: button.url }));

    this.callButtons = callButtons.map((button: any) => ({ title: button.text, value: button.url }));

    this.countQuickReplyButton = this.quickReplyButtons.length;

    this.countCTAButtonForURL = this.urlButtons.length;

    this.renderedData = this.formateData(body);

    console.log('renderedData', this.renderedData);

  }

  splitString(inputString: any) {


    if(inputString === null || inputString === undefined){
      return {
        header: '',
        body: '',
        footer: ''
      };
    }

    // Parse the input string as JSON
    const inputData = JSON.parse(inputString);

    // Extract the header, body (data), and footer from the JSON object
    const { header, data: body, sampleText, footer } = inputData;

    return {
      header: header,
      body: this.updateSampleText(sampleText),
      footer: footer
    };
  }

  updateSampleText(input: string): string {
    return input.replace(/\[(.*?)\]/g, '$1');
  }

  parseButtons(input: string): {
    quickReplyButtons: string[], urlButtons: { text: string, urlType: string, url: string }[],
    callButtons: { text: string, url: string }[]
  } {

    if(input === null || input === undefined){
      return {
        quickReplyButtons: [],
        urlButtons: [],
        callButtons: []
      };
    }

    const quickReplyButtons: string[] = [];
    const urlButtons: { text: string, urlType: string, url: string }[] = [];
    const callButtons: { text: string, url: string }[] = [];

    // Parse the input string as JSON
    const inputData = JSON.parse(input);

    // Assuming buttons field is present in the input JSON
    const { buttons } = inputData;


    if (buttons) {
      buttons.forEach((button: any) => {
        if (button.type === 'QUICK_REPLY') {
          // Add to quickReplyButtons if type is QUICK_REPLY
          quickReplyButtons.push(button.text.trim());
        } else if (button.type === 'URL') {
          // Add to urlButtons if type is URL
          urlButtons.push({ text: button.text.trim(), urlType: "static", url: button.url.trim() });
        } else if (button.type === 'PHONE_NUMBER') {
          // Add to urlButtons if type is URL
          callButtons.push({ text: button.text, url: button.phone_number });
        }
      });
    }

    return { quickReplyButtons, urlButtons, callButtons };
  }



  handleCloseDialog() {
    this.closeDialog.emit();
  }

  formateData(data: any) {
    return data
      .replace(/\n/g, '<br>') // Replace \n with <br>
      .replace(/\*(.*?)\*/g, '<b>$1</b>'); // Replace *text* with <b>text</b>
  }

  showAllOptions() {
    this.showAllVariables = !this.showAllVariables;
  }

}
